'use client'

import { useLocalStorage } from './useLocalStorage'

const MAX_HISTORY_ITEMS = 10

export function useSearchHistory(storageKey: string = 'search-history') {
  const { value: history, setValue: setHistory } = useLocalStorage<string[]>(
    storageKey,
    []
  )

  const addToHistory = (term: string) => {
    const trimmed = term.trim()
    if (!trimmed) return

    setHistory((currentHistory) => {
      const filtered = currentHistory.filter(
        (item) => item.toLowerCase() !== trimmed.toLowerCase()
      )
      const newHistory = [trimmed, ...filtered]
      return newHistory.slice(0, MAX_HISTORY_ITEMS)
    })
  }

  const removeFromHistory = (term: string) => {
    setHistory((currentHistory) =>
      currentHistory.filter(
        (item) => item.toLowerCase() !== term.toLowerCase()
      )
    )
  }

  const clearHistory = () => {
    setHistory([])
  }

  const filterHistory = (query: string) => {
    if (!query.trim()) return history
    return history.filter((item) =>
      item.toLowerCase().includes(query.toLowerCase())
    )
  }

  return {
    history,
    addToHistory,
    removeFromHistory,
    clearHistory,
    filterHistory,
  }
}
